/* eslint-disable no-redeclare */
import { z } from 'zod';

export const QuotesProductType = z.enum([
  'MEDICARE_ADVANTAGE',
  'MEDIGAP',
  'HEALTH_ON_EXCHANGE',
]);

export type QuotesProductType = z.infer<typeof QuotesProductType>;
